(function ($, window, document, undefined) {

    'use strict';
    var pluginName = 'sgSelect',
        defaults = {
            multi: false,
            customClass: ''
        };

    function Plugin(element, options) {
        this.element = element;
        this.settings = $.extend({}, defaults, options);
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    $.extend(Plugin.prototype, {
        init: function () {
            this.customClass = this.settings.customClass || '';

            this.$container = $(this.element);

            // Set a custom class if we have one.
            this.$container.addClass(this.customClass);

            // Data thats been selected
            this.selectedData = [];

            // list of data and open/close handler.
            this.$dataEl = this.$container.find('.sg-select__data-list');
            this.$handler = this.$container.find('.sg-select__handler');

            // Element state
            this.isOpen = false;

            // Setup the component
            this.setupDataList();
            this.setupHandler();
        },
        setupDataList: function () {
            this.$dataEl.css('display', 'none');

            this.$dataEl.on('click', function (event) {
                var $targetEl = $(event.target);

                // If the option is disabled do nothing.
                if ($targetEl.attr('data-disabled')) {
                    return false;
                }

                if ($targetEl.is('li')) {
                    event.stopPropagation();

                    if ($targetEl.data('selected')) {
                        // Multi so deselect it since it was already selected.
                        if (this.settings.multi) {
                            $targetEl.removeClass('sg-select__data-list-items--selected');
                            $targetEl.data('selected', false);

                            this.selectedData.splice(this.selectedData.indexOf($targetEl.data('val')), 1);
                        } else {
                            // Single select always select it
                            this.$handler.find('.sg-select__handler_text').text($targetEl.text());
                            this.selectedData[0] = $targetEl.data('val');
                        }
                        this.$container.trigger("change");
                    } else {
                        // If its a multi select just toggle whats selected, and push the value.
                        if (this.settings.multi) {
                            $targetEl.toggleClass('sg-select__data-list-items--selected');
                            $targetEl.data('selected', true);
                            this.selectedData.push($targetEl.data('val'));
                        } else {
                            // Set the others to false.
                            $targetEl.parent().find('li').each(function () {
                                $(this).data('selected', false);
                            });

                            // Not a multi, so replace the text with the selected option and make 0 the value.
                            this.$handler.find('.sg-select__handler_text').text($targetEl.text());
                            this.selectedData[0] = $targetEl.data('val');
                            $targetEl.data('selected', true);
                        }
                        this.$container.trigger("change");
                    }

                    // Indicates that we have something selected
                    if (this.selectedData.length && this.settings.multi) {
                        this.$handler.addClass('sg-select__handler--data-selected');
                    } else {
                        this.$container.find('.sg-select__handler--data-selected').removeClass('sg-select__handler--data-selected');
                    }

                    this.toggleListState();
                }
            }.bind(this));
        },
        setupHandler: function () {
            // If its not a multi select then the first option should be the text, unless data-selected is set
            if (!this.settings.multi) {
                var $selectedItem = this.$dataEl.find('li').first();

                if (this.$dataEl.find('[data-select]').length) {
                    $selectedItem = this.$dataEl.find('[data-select]');
                    $selectedItem.removeAttr('data-select');

                    $selectedItem.data('selected', true);
                }
                this.$handler.find('.sg-select__handler_text').text($selectedItem.text());
                this.selectedData[0] = $selectedItem.data('val');
            }

            $(document).on('click', function (e) {
                // If clicked anywhere not on the element the menu closes.
                if (!$(e.target).closest(this.$handler).length) {
                    this.closeList();
                } else {
                    this.toggleListState();
                }
            }.bind(this));
        },
        toggleListState: function (open) {
            this.isOpen = !this.isOpen;

            if (this.isOpen) {
                this.$dataEl.css('display', 'block');

                // get the center of the handler element so we can position the list correctly.
                var rect = this.$handler.get(0).getBoundingClientRect(),
                    curLeft = this.$dataEl.get(0).getBoundingClientRect().width,
                    center = rect.left + (rect.width / 2) - (curLeft / 2);

                this.$dataEl.offset({ 'left': center });
                this.$handler.toggleClass('sg-select__handler--open');
            } else {
                this.$handler.toggleClass('sg-select__handler--open');
                this.$dataEl.css('display', 'none');
            }

            this.$dataEl.css('display', this.isOpen ? 'block' : 'none');
        },
        closeList: function () {
            this.isOpen = false;
            this.$container.find('.sg-select__handler--open').removeClass('sg-select__handler--open');
            this.$dataEl.css('display', 'none');
        },
        getSelectedData: function () {
            return this.selectedData;
        }
    });

    // A really lightweight plugin wrapper around the constructor,
    // preventing against multiple instantiations
    $.fn[pluginName] = function (options) {
        var returnValue = null;

        this.each(function () {
            var item = $(this), instance = item.data('plugin_' + pluginName);

            if (!instance) {
                $.data(this, 'plugin_' + pluginName, new Plugin(this, options));
            } else {
                // if instance already created call method
                if (typeof options === 'string') {
                    returnValue = instance[options].apply(instance, arguments);
                }
            }
        });

        if (!returnValue) {
            returnValue = this;
        }

        return returnValue;
    };

})(jQuery, window, document);